import React from 'react';

import Button from 'components/Button/Button';
import {
  FaqType,
  JoinUsPageType,
} from 'containers/JoinUsPage/JoinUsPage.types';
import { useOpportunitiesStore } from 'store';

import * as S from './FaqOverlay.styles';

export interface FaqOverlayProps {
  data: Array<FaqType>;
  pageData: JoinUsPageType;
}

const defaultProps: Partial<FaqOverlayProps> = {};

const FaqOverlay: React.FunctionComponent<FaqOverlayProps> = ({
  data,
  pageData,
  ...rest
}) => {
  const { openOpportunityList } = useOpportunitiesStore();
  return (
    <S.FaqOverlayWrapper {...rest}>
      <S.Title>FAQs</S.Title>
      {data.map(q => (
        <S.QuestionWrapper key={q.question}>
          <S.Title>{q.question}</S.Title>
          <S.Text>{q.answer}</S.Text>
        </S.QuestionWrapper>
      ))}
      <S.OpportunitiesWrapper>
        <S.Title>{pageData.FaqFooterCopy}</S.Title>
        <Button label={pageData.faqCtaLabel} onClick={openOpportunityList} />
      </S.OpportunitiesWrapper>
    </S.FaqOverlayWrapper>
  );
};

FaqOverlay.defaultProps = defaultProps;

export default FaqOverlay;
